<template lang="pug">
  div
    CompanyTableRow(
      @toggleAccordion="toggleAccordion()",
      :job="job",
      :checkedIds="checkedIds",
      :updateFavorForIndex="true",
      :updateMarkForIndex="true",
      @display="display",
      @check="toggleCheck"
    )
    <transition name="fade">
      JobTable(
        v-show="isVisible",
        :jobs="job.inner_hits",
        @display="display",
      )
    </transition>
</template>

<script>
  import { mapActions, mapMutations } from 'vuex'
  import CompanyTableRow from './CompanyTableRow'
  import JobTable from './JobTable'

  export default {
    components: {
      CompanyTableRow,
      JobTable,
    },
    props: ['job', 'checkedIds'],
    data () {
      return {
        isVisible: false,
      }
    },
    methods: {
      ...mapMutations('job', ['check', 'uncheck', 'uncheckAll']),
      ...mapActions('job', ['toggleCheck', 'togglePageCheck']),
      toggleAccordion () {
        this.isVisible = !this.isVisible
      },
      display (id) {
        this.$emit('display', id)
      },
    },
  }
</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .1s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/parts/grouping-job/TableRows.vue